module.exports = __webpack_public_path__ + "static/media/invest-19-logo.dd86e9bc.svg";